var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[("" + _vm.cssPrefix),
    ( _obj = {}, _obj[(_vm.cssPrefix + "--selected")] = _vm.selected, _obj ),
    ( _obj$1 = {}, _obj$1[(_vm.cssPrefix + "--no-border")] = _vm.noBorder, _obj$1 ),
    'sw-flexbox', 'sw-flexbox--center-items','sw-flexbox--row'
  ],on:{"click":_vm.onClickOuter}},[_c('span',{class:[
        (_vm.cssPrefix + "__icon"), 'sw-flexbox__flex-none',
        'sw-flexbox', 'sw-flexbox--center-items', 'sw-flexbox--center-justify',
        [(_vm.cssPrefix + "__icon--big")]
      ],style:(_vm.iconStyle),on:{"mouseenter":_vm.onMouseEnterIcon,"mouseleave":_vm.onMouseLeaveIcon,"click":_vm.onClickIcon}},[_c('span',{class:['sw-flexbox', 'sw-flexbox--center-items','sw-flexbox--row']},[_c('sw-icon',{staticClass:"sw-filter-chips--close",attrs:{"name":'info'}})],1),_vm._v(" "),_c('span',{class:['sw-flexbox', 'sw-flexbox--center-items','sw-flexbox--row']},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    ")])])])
var _obj;
var _obj$1;}
var staticRenderFns = []

export { render, staticRenderFns }